import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-search-rounded-border',
  templateUrl: './search-rounded-border.component.html',
  styleUrls: ['./search-rounded-border.component.scss'],
})
export class SearchRoundedBorderComponent implements OnInit, OnDestroy {
  @Input() placeholder?: string;
  @Output() onInputText = new EventEmitter();
  debounce: Subject<string> = new Subject<string>();

  constructor() {}

  ngOnDestroy(): void {
    this.debounce.unsubscribe();
  }

  ngOnInit(): void {
    if (!this.placeholder) {
      this.placeholder = 'Pesquise aqui ...';
    }
    this.debounce
      .pipe(debounceTime(300))
      .subscribe((text) => this.filter(text));
  }

  filter(searchText: string): void {
    if (searchText && searchText.length > 2) {
      this.onInputText.emit(searchText);
    } else {
      this.onInputText.emit('');
    }
  }
}
